// GENERATED FILE. Do not hand-edit.
//
// Regenerate with:
//   node tools/fetch-soil-legend-colours.mjs 20/08/2026 > src/components/mapLayers/data/soilClassColours.js
//
// Each colour is the modal opaque pixel of the provider's own 20x20 legend
// swatch, pulled from their `/legend?f=json` endpoint, so the key cannot
// contradict the map. Generated 20/08/2026.
//
// A class absent from these tables is not an error: the providers render a few
// classes they do not publish in their legend (England has a "water" class).
// Those fall back to a neutral swatch and keep their name, which is honest.

// England and Wales, Cranfield Soilscapes 1:250k. Keyed on SOILSCAPE, the
// field the map is styled on and the field the zone query returns.
export const SOILSCAPES = {
  "Blanket bog peat soils": '#A800E5',
  "Fen peat soils": '#C19DD6',
  "Freely draining acid loamy soils over rock": '#FE7E7E',
  "Freely draining floodplain soils": '#D6C19D',
  "Freely draining lime-rich loamy soils": '#D6B09D',
  "Freely draining sandy Breckland soils": '#E59700',
  "Freely draining slightly acid but base-rich soils": '#A76E00',
  "Freely draining slightly acid loamy soils": '#CD8764',
  "Freely draining slightly acid sandy soils": '#A70000',
  "Freely draining very acid sandy and loamy soils": '#FE5500',
  "Lime-rich loamy and clayey soils with impeded drainage": '#A7A700',
  "Loamy and clayey floodplain soils with naturally high groundwater": '#00C4FE',
  "Loamy and clayey soils of coastal flats with naturally high groundwater": '#006EFE',
  "Loamy and sandy soils with naturally high groundwater and a peaty surface": '#004DA7',
  "Loamy soils with naturally high groundwater": '#9DA9D6',
  "Naturally wet very acid sandy and loamy soils": '#E50000',
  "Raised bog peat soils": '#FE00C4',
  "Restored soils mostly from quarry and opencast spoil": '#818181',
  "Saltmarsh soils": '#BDE7FE',
  "Sand dune soils": '#E5E500',
  "Shallow lime-rich soils over chalk or limestone": '#FEFE72',
  "Shallow very acid peaty soils over rock": '#FEFEBD',
  "Slightly acid loamy and clayey soils with impeded drainage": '#724B00',
  "Slowly permeable seasonally wet acid loamy and clayey soils": '#4BE500',
  "Slowly permeable seasonally wet slightly acid but base-rich loamy and clayey soils": '#37A700',
  "Slowly permeable wet very acid upland soils with a peaty surface": '#A3FE72',
  "Very acid loamy upland soils with a wet peaty surface": '#FEBDE7',
  "Unsurveyed/Urban": '#F1F1F1',
  "Water body": '#B3F9FE',
};

// Scotland, Hutton National Soil Map 1:250k. Keyed on genSoilTyp, the
// renderer's own field. NOT MSG13_1: the map paints 11 generalised types, so
// keying on the finer soil association would list classes the map does not
// colour apart.
export const HUTTON_GEN_SOIL_TYPE = {
  "Alluvial soils": '#FFFF00',
  "Brown soils": '#734C00',
  "Calcareous soils": '#A87000',
  "Immature soils": '#B2B2B2',
  "Mineral gleys": '#00C5FF',
  "Mineral podzols": '#FFAA00',
  "Montane soils": '#828282',
  "Peat": '#73004C',
  "Peaty gleys": '#38A800',
  "Peaty podzols": '#FF0000',
  "Lochs": '#97DBF2',
};
